<template>
  <div class="loader-modal">
    <div id="loadingMagic" class="loading">
      <div id="loader"><img src="@/assets/images/verde.svg" /></div>
      <div id="loader2"><img src="@/assets/images/azul.svg" /></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Loader",
};
</script>

<style lang="scss" scoped>
.loader-modal {
  width: 100%;
  height: 100%;
  position: fixed;
  background: rgba(0, 0, 0, 0.253);
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  transition: 200ms ease-out;
  /* Novo loader*/
  .loading {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 10050; /* o z-index do datepicker é 10002*/
    background-color: rgb(0, 0, 0); /* Black fallback color */
    background-color: rgba(0, 0, 0, 0.8); /* Black w/opacity */
  }

  .loading .simbolo {
    position: absolute;
    left: 50%;
    top: 410px;
    margin: -30px 0 0 -31px;
  }

  #loader {
    position: absolute;
    left: 50%;
    top: 410px;
    z-index: 1;
    width: 70px;
    height: 70px;
    margin: -35px 0 0 -35px;

    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
  }

  #loader2 {
    position: absolute;
    left: 50%;
    top: 410px;
    z-index: 1;
    width: 70px;
    height: 70px;
    margin: -35px 0 0 -35px;

    -webkit-animation: spinreverse 2s linear infinite;
    animation: spinreverse 2s linear infinite;
  }

  #loaderProgress {
    position: absolute;
    top: 510px;
    z-index: 2;
    width: 100%;
    text-align: center;
  }

  #loaderProgress div {
    color: white;
    // background-color: #FFF;
    min-width: 200px;
    margin: 0 auto;
    border-radius: 3px;
    overflow: hidden;
    display: table;
  }

  @-webkit-keyframes spin {
    from {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    to {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  @keyframes spin {
    from {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    to {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  @-webkit-keyframes spinreverse {
    from {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
    to {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
  }

  @keyframes spinreverse {
    from {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
    to {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
  }
}
</style>
